import * as React from 'react';
import {
  Button,
  DataGrid,
  Icon,
  IconSize,
  IconType,
  ISelectOption,
  SeeMoreLessBlock,
  SeeMoreLessSize,
} from 'ui-toolkit';

interface ILenderTable {
  data: Array<ISelectOption<string>>;
  loading: boolean;
  removeLender: (id: string) => void;
}

export const LendersTable: React.FC<ILenderTable> = ({ data = [], loading, removeLender }) => (
  <>
    <SeeMoreLessBlock maxHeight={SeeMoreLessSize.large}>
      <DataGrid
        columns={[
          {
            dataField: 'label',
            text: 'Lenders',
          },
          {
            dataField: 'value',
            text: '',
            formatter: (_, row) => (
              <Button intent={'ghost'} isInline onClick={() => removeLender(row.value)}>
                <Icon type={IconType.Remove} size={IconSize.Small} />
              </Button>
            ),
          },
        ]}
        defaultSortDirection="asc"
        data={data}
        loading={loading}
        keyField="value"
      />
    </SeeMoreLessBlock>
  </>
);
